import React from 'react'
import MaterialSymbol from '../material-symbol'

const ErrorOutline = React.forwardRef((props, ref) => (
  <MaterialSymbol ref={ref} name="error_outline" {...props} />
))

ErrorOutline.displayName = 'ErrorOutline'

export default ErrorOutline
